<template>
  <div class="ac1">
    <!-- 导航栏 -->
    <nav-header :href="this.href"></nav-header>

    <!-- 动漫展示 st -->
    <div class="cm2">
      <div class="container">
        <!-- 标题 -->
        <div class="cm2__title">
          <h2>Animation products</h2>
          <p><i></i> <span>动漫产品</span> <i></i></p>
        </div>

        <!-- 容器 -->
        <div class="con">
          <!-- 容器列表 -->
          <div class="con-list" v-for="(item, index) in cm2" :key="index">
            <div class="l">
              <img :src="item.img" alt="" />
              <h4>{{ item.name }}</h4>
              <a href="javascript:;" class="l-btn" @click="goDetails(item.id)">观看全部</a>
            </div>
            <div class="r">
              <!-- 图片循环项 -->
              <div class="r-item" v-for="j  in item.imgList" :key="j">
                <img :src="j" alt="" />
              </div>
            </div>
          </div>

        </div>

        <!-- 更多按钮 -->
        <!-- <a href="" class="cm2__button">MORE</a> -->
      </div>
    </div>
    <!-- 动漫展示 end -->
  </div>
</template>

<script>
import NavHeader from "./../components/NavHeader";
export default {
  name: "ac1",
  components: {
    NavHeader,
  },
  data() {
    return {
      href: "index.html",
      listac: 'ac',
      cm2: [],
      myData: [],
      mAc: [],
      imgUrl: "",
      showModal: false,
      state: JSON.parse(window.localStorage.getItem("state")),
    };
  },
  mounted() {
    this.init();
    document.title = "晋江奇境";
  },
  methods: {
    // 渲染数据
    init() {

      // 动漫展示
      this.axios.get("/mock/list.json").then((res) => {
        var data = res.data;
        this.cm2 = data;
      });
    },
    // 真实支付逻辑
    alipay(data) {
      console.log(data);
      var payAmount = 1.0; //支付价格
      var orderName = "动漫支付下载"; //订单名称
      var id = data.type; //订单名称

      // 已登录
      if (this.state == 0) {
        window.open(
          "http:///alipay/index.php?payAmount=" +
          payAmount +
          "&orderName=" +
          orderName +
          "&id=" +
          id
        );
      }
      // 未登录
      if (this.state !== 0) {
        alert("点击登录去购买~");
        this.$router.push({ path: "/login", query: { k: 1 } });
        return;
      }
    },
    // 跳转功能
    goDays(methodsWords, id) {
      this[methodsWords](id);
    },
    // 跳转详情页
    goDetails(id) {
      this.$router.push({
        path: "/sound/:" + id,
        query: { type: id },
      });
    },
    // 收费逻辑
    gopay() {
      // console.log('1')
      alert("请付费下载图片！");
      this.showModal = true;

      // if (this.state == 0) {
      //   // this.$router.push("/pay");
      //   this.showModal = true;
      //   console.log(this.showModal);
      // }
      // // 未登录
      // if (this.state !== 0) {
      //   alert("资讯每条2元，点击确定登录购买");
      //   this.$router.push({ path: "/login", query: { k: 1 } });
      //   return;
      // }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

// 动漫展示
.cm2 {
  margin: 40px 0;

  // 标题
  &__title {
    text-align: center;

    h2 {
      font-size: 33px;
      line-height: 46.2px;
      color: #e3e3e0;
      font-weight: bold;
    }

    p {
      color: rgb(67, 67, 67);
      font-size: 24px;
      display: flex;
      align-items: center;
      justify-content: center;

      span {
        margin: 10px 15px;
      }

      i {
        width: 10px;
        height: 4px;
        background: #000;
        display: inline-block;
      }
    }
  }

  // 容器
  .con {
    width: 100%;

    // 容器列表
    .con-list {
      width: 100%;
      height: 300px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 1px solid #ccc;
      margin: 35px 0;

      .l {
        width: 28%;
        height: 100%;
        text-align: center;
        border-right: 1px solid #ccc;

        img {
          width: 180px;
          height: 180px;
          background-color: #fff;
          margin: 25px 0;
        }

        h4 {
          font-size: 12px;
          font-weight: bold;
        }

        .l-btn {
          width: 130px;
          height: 35px;
          background: #4bc0bf;
          margin: 0 auto;
          margin-top: 10px;
          color: #fff;
          line-height: 35px;
          font-size: 12px;
          cursor: pointer;
          display: block;
          text-decoration: none;
          transition: all 0.5s;

          &:hover {
            background-color: rgba(67, 67, 67, 1);
          }
        }
      }

      .r {
        width: 70%;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;

        .r-item {
          width: 120px;
          height: 120px;
          margin: 15px;
          // background: #000;
          cursor: pointer;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }

  // 更多按钮
  .cm2__button {
    width: 312px;
    height: 54px;
    line-height: 54px;
    margin: 10px auto;
    background-color: #4bc0bf;
    color: #fff;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
    display: block;
    text-decoration: none;
    transition: all 0.5s;

    &:hover {
      background-color: rgba(67, 67, 67, 1);
    }
  }
}
</style>
